import HTMLParser from 'html-react-parser';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { useClientTranslation } from '@/lib/core/i18n';

interface ProductInfoAccordionProps {
  descriptionHtml?: string | null;
  deliveryReturnsHtml?: string | null;
}

/**
 * Two-section accordion for the product detail page. Sections are collapsed
 * by default (Radix `Accordion` with no `defaultValue`) and render sanitized
 * HTML from the backend when provided.
 */
export function ProductInfoAccordion({ descriptionHtml, deliveryReturnsHtml }: ProductInfoAccordionProps) {
  const t = useClientTranslation();

  return (
    <Accordion type="multiple" className="border-jncquoi-neutral-900 border-b-[0.5px]">
      <AccordionItem value="description">
        <AccordionTrigger>{t('App.Shop.Description')}</AccordionTrigger>
        <AccordionContent className="font-pp-neue-montreal text-jncquoi-neutral-1000 prose prose-sm max-w-none pb-4 text-[14px] leading-normal font-[350] tracking-[0.5px]">
          {descriptionHtml ? HTMLParser(descriptionHtml) : <p>—</p>}
        </AccordionContent>
      </AccordionItem>

      <AccordionItem value="delivery">
        <AccordionTrigger>{t('App.Shop.DeliveryReturns')}</AccordionTrigger>
        <AccordionContent className="font-pp-neue-montreal text-jncquoi-neutral-1000 prose prose-sm max-w-none pb-4 text-[14px] leading-normal font-[350] tracking-[0.5px]">
          {deliveryReturnsHtml ? HTMLParser(deliveryReturnsHtml) : <p>—</p>}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
